
export default class EMFBoundingBox extends THREE.LineSegments {
  constructor (color = new THREE.Color(0x00939D)) {
    let geom = new THREE.BufferGeometry();
    super(geom, new THREE.LineBasicMaterial({
      color: color
    }));
    this.frustumCulled = false;
    this.center = new THREE.Vector3();
    this.size = new THREE.Vector3();
    this.corners = {
      x: new THREE.Vector3(),
      y: new THREE.Vector3(),
      z: new THREE.Vector3()
    };
  }

  setColor (color) {
    if (color instanceof THREE.Color) {
      this.material.color = color;
    } else {
      this.material.color = new THREE.Color(color);
    }
  }

  update (container) {
    let box = new THREE.Box3();

    container.updateMatrixWorld(true);
    container.traverse(object => {
      // if (object instanceof EMFMesh) {
      box.expandByObject(object);
      // }
    });

    let min = box.min;
    let max = box.max;

    let p0 = new THREE.Vector3(min.x, min.y, min.z);
    let p1 = new THREE.Vector3(max.x, min.y, min.z);
    let p2 = new THREE.Vector3(max.x, min.y, max.z);
    let p3 = new THREE.Vector3(min.x, min.y, max.z);
    let p4 = new THREE.Vector3(min.x, max.y, min.z);
    let p5 = new THREE.Vector3(max.x, max.y, min.z);
    let p6 = new THREE.Vector3(max.x, max.y, max.z);
    let p7 = new THREE.Vector3(min.x, max.y, max.z);

    this.geometry.dispose();

    const vertices = [
      p0, p1, p1, p2, p2, p3, p3, p0, // bottom
      p0, p4, p1, p5, p2, p6, p3, p7, // side
      p4, p5, p5, p6, p6, p7, p7, p4 // top
    ];
    const array = [];
    vertices.forEach(v => {
      array.push(v.x, v.y, v.z);
    });

    const geometry = new THREE.BufferGeometry();
    geometry.setAttribute('position', new THREE.BufferAttribute(new Float32Array(array), 3));
    this.geometry = geometry;
    this.geometry.computeBoundingBox();

    box.getCenter(this.center);
    box.getSize(this.size);
    this.corners.x.copy((new THREE.Vector3()).addVectors(p0, p1).multiplyScalar(0.5));
    this.corners.y.copy((new THREE.Vector3()).addVectors(p1, p5).multiplyScalar(0.5));
    this.corners.z.copy((new THREE.Vector3()).addVectors(p1, p2).multiplyScalar(0.5));
  }

  getWorldCorners () {
    const x = this.localToWorld(this.corners.x.clone());
    const y = this.localToWorld(this.corners.y.clone());
    const z = this.localToWorld(this.corners.z.clone());
    return {
      x, y, z
    };
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/EMFBoundingBox.js